// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"kF-z","smallCardRow":"lF-z","largeCardRow":"mF-z","productSearchRow":"nF-z","curatedRow":"oF-z"};